import { useEffect } from 'react'
import { useLocation } from 'wouter'
import { useShallow } from 'zustand/react/shallow'
import queryClient from '@/queryClient'
import { QUERY_KEYS as CAD_QUERY_KEYS } from '@/services/queries/cads'
import { useCADPageStore } from '@/state/cad'
import { useTimeTravelStore } from '@/lib/timeTravel/timeTravelStore'

const useCADGC = () => {
  const [location] = useLocation()
  const resetCadPageStore = useCADPageStore(useShallow((state) => state.reset))
  const resetTimeTravelStore = useTimeTravelStore(
    useShallow((state) => state.reset),
  )

  useEffect(() => {
    const isCadPage = location.match(/cad$/)
    const isDocumentPage = location.match(/edit$/)
    const shouldGC = !isCadPage && !isDocumentPage
    if (shouldGC) {
      queryClient.removeQueries({
        queryKey: [CAD_QUERY_KEYS.GLTF],
      })
      resetCadPageStore()
      resetTimeTravelStore()
    }
  }, [location, resetCadPageStore, resetTimeTravelStore])
}

export const GarbageCollector = () => {
  useCADGC()

  return null
}
